import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import { GenDocLinkContainerModel, GenericDocLinkContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { bl_fi_generic_doc_link_RowClass } from '../../../../../../models/dbschema/bl_fi_generic_doc_link.model';


@Injectable({
  providedIn: 'root'
})
export class GenericDocLinkBackofficeEPService extends BaseApiTemplateService<GenDocLinkContainerModel[]> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + 'generic-doc/links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/links/backoffice-ep';
    this.httpClient = http;
  }

  knockOffDoc(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    const knockOffEndpoint = 'core2/tnt/dm/erp/generic-doc/links/knock-off/backoffice-ep';
    const fullUrl = visa.api_domain_url
      ? visa.api_domain_url + knockOffEndpoint
      : Core2Config.DOMAIN_URL + knockOffEndpoint;

    return this.httpClient.post<ApiResponseModel<any>>(
      fullUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  knockOffDraftDoc(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    const knockOffDraftEndpoint = 'core2/tnt/dm/erp/generic-doc/links/knock-off-draft/backoffice-ep';
    const fullUrl = visa.api_domain_url
      ? visa.api_domain_url + knockOffDraftEndpoint
      : Core2Config.DOMAIN_URL + knockOffDraftEndpoint;

    return this.httpClient.post<ApiResponseModel<any>>(
      fullUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
